import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PUBLISHER_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_PUBLISHER: TypedDocumentNode<Data, Variables> = gql`
  ${PUBLISHER_FRAGMENT}

  query getPublisher($id: ID!) {
    node(id: $id) {
      ... on User {
        ...PublisherFragment
      }
    }
  }
`
